module.exports = __webpack_public_path__ + "static/img/img-bg-canvas.878db15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-bg-canvas.png
// module id = NtNh
// module chunks = 36